import { render } from "./SearchInsurer.vue?vue&type=template&id=f6ec094a"
import script from "./SearchInsurer.vue?vue&type=script&lang=js"
export * from "./SearchInsurer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__